import { render, staticRenderFns } from "./CreateProfileRole.vue?vue&type=template&id=96f6dff6&"
import script from "./CreateProfileRole.vue?vue&type=script&lang=js&"
export * from "./CreateProfileRole.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports